import { showAlert } from '../../../../utilities/notifications';
import { WalletScreens } from '../../constants';

const completeLedgerFund = ({ success, openScreen, screenOptions, translate }) => {
  if (!success) {
    showAlert({ message: translate('wallet_fund_failed'), type: 'danger' });
    return;
  }

  openScreen(WalletScreens.TRANSACTION_PROCESSED, screenOptions);
};

export default completeLedgerFund;
